import {
  CheckboxGroup,
  Input,
  Loader,
  MantineColorsTuple,
  Modal,
  NumberInput,
  RadioGroup,
  Select,
  Text,
  Textarea,
  colorsTuple,
  createTheme,
} from '@mantine/core';
import classes from 'global.module.css';

export const NAVBAR_COLLAPSED_SIZE = 103;
export const NAVBAR_EXPANDED_SIZE = 250;

export const colors = {
  white: colorsTuple('#fff'),
  black: colorsTuple('#000'),
  transparent: colorsTuple('rgba(255, 255, 255, 0)'),
  uncertain: colorsTuple('rgba(255, 0, 255, 0.8)'),
  shell: colorsTuple('#F1F3F5'),
  purple: colorsTuple('#862E9C'),
  conductionBlue: colorsTuple('#609EE6'),
  heartRateOutOfRange: colorsTuple('rgba(255, 233, 168, 0.3)'),
  chartPlotLines: [
    '#F2F2F2',
    '#F2F2F2',
    '#C3D2E1',
    '#C3D2E1',
    '#BFBFBF',
    '#BFBFBF',
    '#888888',
    '#888888',
    '#000000',
    '#000000',
  ] as MantineColorsTuple,
  peach: [
    '#FBECDE',
    '#FBECDE',
    '#FBECDE',
    '#FBECDE',
    '#FFA786',
    '#FFA786',
    '#DF6F45',
    '#DF6F45',
    '#B6491A',
    '#B6491A',
  ] as MantineColorsTuple,
  red: [
    'rgba(249, 222, 219, 0.8)',
    'rgba(249, 222, 219, 0.8)',
    '#F5D0CA',
    '#F5D0CA',
    '#AE1818',
    '#AE1818',
    '#7a1111',
    '#7a1111',
    '#680e0e',
    '#680e0e',
  ] as MantineColorsTuple,
  turquoise: [
    '#EBF6F4',
    '#EBF6F4',
    '#78BBBF',
    '#78BBBF',
    '#1e8d95',
    '#1e8d95',
    '#0F676D',
    '#0F676D',
    '#0f474b',
    '#0f474b',
  ] as MantineColorsTuple,
  blue: [
    '#E3EDF6',
    '#E3EDF6',
    '#2F5C8A',
    '#2F5C8A',
    '#184A7D',
    '#184A7D',
    '#1D3446',
    '#1D3446',
    '#192633',
    '#192633',
  ] as MantineColorsTuple,
  gray: [
    '#DEE2E6',
    '#DEE2E6',
    '#CED4DA',
    '#CED4DA',
    '#ACAFB5',
    '#ACAFB5',
    '#5C5E62',
    '#5C5E62',
    '#212529',
    '#212529',
  ] as MantineColorsTuple,
};

const components = {
  NumberInput: NumberInput.extend({
    styles: {
      input: {
        width: 70,
      },
    },
  }),
  Input: Input.extend({
    styles: {
      wrapper: {
        fontSize: 'var(--mantine-font-size-sm)',
      },
      input: {
        color: 'var(--mantine-color-blue-7)',
        '::placeholder': {
          color: 'var(--mantine-color-gray-7)',
        },
      },
    },
  }),
  InputWrapper: Input.Wrapper.extend({
    classNames: {
      label: classes.formLabel,
    },
  }),
  Select: Select.extend({
    defaultProps: {
      withCheckIcon: false,
      allowDeselect: false,
    },
    classNames: { option: classes.selectOption, label: classes.formLabel },
  }),
  RadioGroup: RadioGroup.extend({
    classNames: { label: classes.formLabel },
  }),
  CheckboxGroup: CheckboxGroup.extend({
    classNames: { label: classes.formLabel },
  }),
  Loader: Loader.extend({
    defaultProps: {
      size: 'sm',
      color: 'var(--mantine-color-blue-5)',
    },
  }),
  Modal: Modal.extend({
    styles: {
      title: {
        fontSize: 'var(--mantine-font-size-lg)',
        fontWeight: 'bold',
      },
    },
  }),
  Text: Text.extend({
    styles: {
      root: {
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
      },
    },
  }),
  Textarea: Textarea.extend({
    styles: {
      input: {
        overflow: 'hidden',
      } /* Fixes Mantine rounding issue causing scrollbar to appear on very specific sizes */,
    },
  }),
};

export const theme = createTheme({
  colors,
  primaryShade: 5,
  components,
  cursorType: 'pointer',
});
